// export const BASEURL = "http://10.79.184.39:8000/api/v1";
// export const BASEURL = "https://test.svasth.ai/api/v1";
export const BASEURL = "https://svasth.ai/api/v1";


// export const BASEURL = "http://192.168.0.194:8000/api/v1";
export const ENDPOINT = {
  // Existing APIs
  Savr: (pin) => `${BASEURL}/savr?pin=${pin}`,
  Validation: `${BASEURL}/validation`,
  GetDetails: (pin) => `${BASEURL}/getdetails?pin=${pin}`,
  Emergency_Call: (id, name, txnId) =>
    `${BASEURL}/emergency_call?id=${id}&name=${name}&txnId=${txnId}`,

  // 🤖 AI APIs (ONLY THESE 3 ARE IMPORTANT)
  voiceAssistant: `${BASEURL}/qa`,
  AnalyzeInjury: `${BASEURL}/analyze-injury`,

}
